"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var MethodFactory_1 = require("./MethodFactory");
var events_1 = require("events");
var axios_1 = require("axios");
var i18n_1 = require("./utils/i18n");
var PaymentModule_1 = require("./modules/web/PaymentModule");
var MandatoryFields_1 = require("./modules/MandatoryFields");
var interpolate_1 = require("./utils/interpolate");
var paymentsApi_1 = require("./paymentsApi");
var biLogger_1 = require("./utils/biLogger");
var config = require('./assets/config.json');
var defaults = {
    selector: 'body',
    query: {},
    type: 'BUYER',
    styles: {},
    walletPaymentInNewTab: false,
};
// This payment provider is not available at the moment. Please try again in a few minutes.
var DEFAULT_ERROR_CODE = 999;
var CashierPayments = /** @class */ (function () {
    function CashierPayments(resources) {
        var _this = this;
        this.modules = {};
        this.addMethod = function (methodId, props) {
            var _props = props || {};
            return _this.methodFactory.addMethod(methodId, __assign({ localizeError: _this.localizeError }, _this.props, _props, { paymentModule: _this.paymentModule }));
        };
        this.getPaymentMethodMetadata = function (methodId) {
            var foundMethod = _this.methodFactory.getMethod(methodId);
            if (foundMethod) {
                return __assign({ id: methodId }, foundMethod.getMetadata());
            }
            return Promise.reject({ code: 404 });
        };
        this.populateMethodFactory = function (data) {
            if (data && data.paymentMethods) {
                data.paymentMethods = data.paymentMethods.map(function (pm) {
                    return __assign({}, pm, { icon: i18n_1.translate("icons." + pm.paymentMethod), name: i18n_1.translate(pm.paymentMethod) });
                });
                data.paymentMethods.forEach(function (paymentMethod) {
                    var squareAppId = '';
                    if (paymentMethod && paymentMethod.paymentMethod === 'creditCard' && paymentMethod.additionalInfo) {
                        squareAppId = paymentMethod.additionalInfo.squareAppId;
                    }
                    var query = Object.assign({}, _this.props.query, {
                        providerId: paymentMethod.connectedProviderId,
                        squareAppId: squareAppId || ''
                    }, paymentMethod.additionalInfo || {}, !!paymentMethod.installments ? { creditCardMaxInstallments: paymentMethod.installments.maxInstallments } : {}, !!paymentMethod.installments ? { creditCardMinInstallments: paymentMethod.installments.minInstallments } : {}, !!paymentMethod.installments ? { isInstallmentsSupported: true } : {});
                    _this.addMethod(paymentMethod.paymentMethod, Object.assign({}, _this.props, { query: query, paymentModule: _this.paymentModule }));
                });
            }
            return data;
        };
        this.fetchPaymentMethods = function (host, settingsRequestUrl, countryCode3, noPopulate) {
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            return _this.i18nPromise.then(function () {
                // example of real url
                // 'https://cashier-services.wix.com/_api/payment-services-web/payments/v2/orders/88889d4e-5233-47b7-b4f2-857b72f12813/payment-methods?country=ISR'
                var extraParams = [];
                if (countryCode3) {
                    extraParams.push("country=" + countryCode3);
                }
                if (_this.props.query && _this.props.query.amount) {
                    extraParams.push("amount=" + _this.props.query.amount);
                }
                var extraParamsString = extraParams.length ? ('?' + extraParams.join('&')) : '';
                return axios_1.default.get(host + ("" + settingsRequestUrl + extraParamsString)).then(function (response) {
                    if (noPopulate) {
                        return response.data;
                    }
                    var populatedData = _this.populateMethodFactory(response.data) || {};
                    var filteredMethods = (populatedData.paymentMethods || []).filter(function (method) { return method.paymentMethod !== 'squarePOS' && method.paymentMethod !== 'pos'; });
                    return __assign({}, populatedData, { paymentMethods: filteredMethods });
                });
            });
        };
        this.getSettingsRequestUrl = function (configuration) {
            var accountId = configuration.appId + ":" + configuration.appInstanceId;
            var baseUrl = !configuration.snapshotId ? config.paymentMethodsAccountApiUrl : config.paymentMethodsOrderApiUrl;
            return interpolate_1.default(baseUrl, { accountId: accountId, orderId: configuration.snapshotId });
        };
        this.fetchPaymentMethodSettings = function (paymentMethod, _a, host) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, orderId = _a.orderId;
            return new Promise(function (resolve, reject) {
                _this.resolveCountry(host).then(function (result) {
                    var country = result.country || '';
                    paymentsApi_1.default.fetchPaymentMethodSettings({ appId: appId, appInstanceId: appInstanceId, orderId: orderId, paymentMethod: paymentMethod, country: country }, host).then(function (data) {
                        resolve(__assign({}, data, { countryCode: result && result.country }));
                    }).catch(function (e) { return console.log(e) || reject({
                        status: 'FAILURE',
                        errorCode: '500',
                        translatedError: ''
                    }); });
                }).catch(function () { return reject({
                    status: 'FAILURE',
                    errorCode: '500',
                    translatedError: ''
                }); });
            });
        };
        this.fetchPaymentMethodsByConfiguration = function (configuration, country, host) {
            if (country === void 0) { country = ''; }
            if (host === void 0) { host = ''; }
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            var noPopulate = true;
            return _this.fetchPaymentMethods(host, _this.getSettingsRequestUrl(configuration), country, noPopulate);
        };
        this.fetchSettings = function (configuration, host) {
            if (host === void 0) { host = ''; }
            if (!configuration.appInstanceId || !configuration.appId) {
                return null; //TODO: throw relevant missing params error here
            }
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            var settingsRequestUrl = _this.getSettingsRequestUrl(configuration);
            return new Promise(function (resolve, reject) {
                _this.resolveCountry(host).then(function (result) {
                    _this.fetchPaymentMethods(host, settingsRequestUrl, result && result.country)
                        .then(function (data) { return resolve(__assign({}, data, { countryCode: result && result.country })); })
                        .catch(function () { return reject({
                        status: 'FAILURE',
                        errorCode: '500',
                        translatedError: ''
                    }); });
                }).catch(function () {
                    // TODO currently this needed for backcompability, to not broke production
                    _this.fetchPaymentMethods(host, settingsRequestUrl, '')
                        .then(function (data) { return resolve(data); })
                        .catch(function () { return reject({
                        status: 'FAILURE',
                        errorCode: '500',
                        translatedError: ''
                    }); });
                });
            });
        };
        this.setActivePaymentMethod = function (pmId) {
            _this.activePaymentMethod = pmId;
            if (_this.props.onPaymentMethodChanged) {
                _this.props.onPaymentMethodChanged(pmId, { type: 'PAYMENT_METHOD_CHANGED', pmId: pmId });
            }
        };
        this.init = function (configuration, linkToWindow) {
            if (configuration === void 0) { configuration = {}; }
            var type = configuration.type !== 'RAW' ? { selector: configuration.selector } : {};
            _this.props = __assign({}, defaults, configuration, type);
            _this.eventEmitter = new events_1.EventEmitter();
            _this.i18nPromise = new Promise(function (resolve) {
                _this.i18n = i18n_1.init(_this.props.query.locale || 'en', _this.resources, function () {
                    resolve();
                });
            });
            var _a = _this.props, appId = _a.appId, appInstanceId = _a.appInstanceId, snapshotId = _a.snapshotId, onMerchantSettingsFetch = _a.onMerchantSettingsFetch, msid = _a.msid, visitorId = _a.visitorId;
            _this.linkToWindow = linkToWindow;
            _this.methodFactory = new MethodFactory_1.default();
            _this.paymentModule = new PaymentModule_1.default(_this.localizeError, linkToWindow, _this.props, _this.eventEmitter);
            var shouldPrefetch = !configuration.noPrefetchOnInit;
            if (shouldPrefetch) {
                _this.tryAutoFetchSettings({ appId: appId, appInstanceId: appInstanceId, snapshotId: snapshotId, onMerchantSettingsFetch: onMerchantSettingsFetch });
            }
            _this.modules.mandatoryFields = new MandatoryFields_1.default();
            biLogger_1.default.init({
                type: _this.props.biType || 'web',
                appId: appId,
                appInstanceId: appInstanceId,
                visitorId: visitorId,
                msid: msid,
                orderSnapshotId: snapshotId,
                host: _this.props.biHost,
            });
            return true;
        };
        this.on = function (event, handler) {
            _this.eventEmitter.on(event, handler);
        };
        this.off = function (event, handler) {
            _this.eventEmitter.removeListener(event, handler);
        };
        this.tryAutoFetchSettings = function (_a) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, snapshotId = _a.snapshotId, onMerchantSettingsFetch = _a.onMerchantSettingsFetch;
            var handler = onMerchantSettingsFetch || (function () { return false; });
            var resultPromise = _this.fetchSettings({ appId: appId, appInstanceId: appInstanceId, snapshotId: snapshotId });
            resultPromise && resultPromise.then(function (res) {
                handler(null, res);
            }).catch(function (err) { return handler(err, {}); });
        };
        this.render = function (method, node) {
            if (!_this.methodFactory) {
                return Promise.reject({
                    status: 'FAILURE',
                    errorCode: 500,
                    translatedError: method + " not inited",
                    paymentMethod: method
                });
            }
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod) {
                return foundMethod.render(node);
            }
        };
        this.setMandatoryField = function (name, field) { return _this.modules.mandatoryFields.setMandatoryField(name, field); };
        this.getMandatoryFieldsMap = function () { return _this.modules.mandatoryFields.getMandatoryFieldsMap(); };
        this.reload = function () {
            _this.remove();
            _this.init(_this.props, _this.linkToWindow);
            return true;
        };
        this.remove = function () {
            _this.methodFactory && _this.methodFactory.remove();
            return true;
        };
        this.submit = function (method) { return _this.pay(method); };
        this.expand = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.expand) {
                return foundMethod.expand(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.collapse = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.collapse) {
                return foundMethod.collapse(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.validate = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod) {
                return foundMethod.validate(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.launchPaymentPopup = function (method, _a) {
            var chargeResponse = (_a === void 0 ? { chargeResponse: {} } : _a).chargeResponse;
            return _this.paymentModule.launchPaymentPopup(method, { chargeResponse: chargeResponse });
        };
        this.cancelPaymentPopup = function (method) {
            return _this.paymentModule.cancelPaymentPopup();
        };
        this.continuePayment = function (method, _a) {
            var _b = _a === void 0 ? { chargeResponse: {}, inNewTab: false } : _a, chargeResponse = _b.chargeResponse, inNewTab = _b.inNewTab;
            return _this.paymentModule.continuePayment(method, { chargeResponse: chargeResponse, inNewTab: inNewTab });
        };
        this.getCreditCardPublicData = function () {
            var method = _this.methodFactory.getMethod('creditCard');
            if (method && method.getCreditCardPublicData) {
                return method.getCreditCardPublicData();
            }
        };
        this.tokenize = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.tokenize) {
                return foundMethod.tokenize(method || _this.activePaymentMethod);
            }
            return Promise.reject({ code: 404 });
        };
        this.setInstallments = function (method, installments) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.setInstallments) {
                foundMethod.setInstallments(installments || 1);
            }
        };
        this.localizeError = function (errorCode, locale) {
            return new Promise(function (resolve) {
                var defaultLocale = _this.props.query && _this.props.query.locale;
                var currentLocale = locale || defaultLocale || 'en';
                var isLanguageLoaded = _this.i18n && _this.i18n.store && _this.i18n.store.data && _this.i18n.store.data[currentLocale];
                if (!_this.i18n || !isLanguageLoaded) {
                    _this.i18nPromise = new Promise(function (i18nPromiseResolve) {
                        _this.i18n = i18n_1.init(currentLocale, null, function () { return setTimeout(function () {
                            i18nPromiseResolve();
                            resolve(i18n_1.errorCodeToMessage(errorCode, locale));
                        }); });
                    });
                }
                else {
                    return resolve(i18n_1.errorCodeToMessage(errorCode, currentLocale));
                }
            });
        };
        this.pay = function (method) {
            var foundMethod = _this.methodFactory.getMethod(method || _this.activePaymentMethod);
            if (foundMethod && foundMethod.pay) {
                return foundMethod.pay(method || _this.activePaymentMethod, _this.getMandatoryFieldsMap())
                    .catch(function (e) {
                    var error = typeof e !== 'object' || !e.errorCode ? { errorCode: 500 } : e;
                    if (_this.props.onError) {
                        _this.props.onError(method, {
                            type: 'PAYMENT_ERROR',
                            error: error
                        });
                    }
                    return error;
                });
            }
            return Promise.reject({ code: 404 });
        };
        this.saveCreditCard = function (creditCard, host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.post(host + config.creditCardsUrl, { creditCard: creditCard }).then(function (response) { return response.data; });
        };
        this.fetchSavedCreditCards = function (host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.get(host + config.creditCardsUrl).then(function (response) { return response.data; });
        };
        this.fetchSavedCreditCard = function (id, host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.get("" + host + config.creditCardsUrl + "/" + id).then(function (response) { return response.data; });
        };
        this.fetchMandatoryFields = function (fetchConfig, host) {
            if (host === void 0) { host = ''; }
            return __awaiter(_this, void 0, void 0, function () {
                var countryResponse, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!host && this.props && this.props.host) {
                                host = this.props.host;
                            }
                            countryResponse = {};
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.resolveCountry(host)];
                        case 2:
                            countryResponse = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            console.error(e_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, this.modules.mandatoryFields.fetchMandatoryFields(fetchConfig, countryResponse.country, host)];
                    }
                });
            });
        };
        this.logMandatoryFieldsValidationStatus = function (data) {
            biLogger_1.default.mandatoryFieldsValidation(data);
        };
        this.updateSavedCreditCard = function (creditCard, metaData, host) {
            if (metaData === void 0) { metaData = { fieldMask: '*' }; }
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.patch("" + host + config.creditCardsUrl + "/" + creditCard.creditCardId, __assign({ creditCard: creditCard }, metaData)).then(function (response) { return response.data; });
        };
        this.deleteSavedCreditCard = function (creditCardId, host) {
            if (host === void 0) { host = 'https://cashier.wix.com'; }
            return axios_1.default.delete("" + host + config.creditCardsUrl + "/" + creditCardId).then(function (response) { return response.data; });
        };
        this.saveBillingAddress = function (creditCardId, billingAddress, host) {
            if (host === void 0) { host = ''; }
            return _this.updateSavedCreditCard({
                creditCardId: creditCardId,
                creditCard: { billingAddress: billingAddress }
            }, { fieldMask: 'creditCard.billingAddress.*' }, host);
        };
        this.updateSavedBillingAddress = function (creditCardId, billingAddress, host) {
            if (host === void 0) { host = ''; }
            return _this.updateSavedCreditCard({
                creditCardId: creditCardId,
                creditCard: { billingAddress: billingAddress }
            }, { fieldMask: 'creditCard.billingAddress.*' }, host);
        };
        this.makeCreditCardPrimary = function (creditCardId, host) {
            if (host === void 0) { host = ''; }
            return axios_1.default.post("" + host + config.creditCardsUrl + "/" + creditCardId + "/primary").then(function (response) { return response.data; });
        };
        this.charge = function (request, host) {
            if (host === void 0) { host = ''; }
            return new Promise(function (resolve, reject) { return paymentsApi_1.default
                .charge({ request: request, host: host || _this.props.host })
                .then(function (result) { return resolve(result); })
                .catch(_this.handleRequestError.bind(_this, { request: request, reject: reject })); });
        };
        this.handleRequestError = function (props, e) {
            var status = e && e.response && e.response.status;
            _this.localizeError(e.errorCode || DEFAULT_ERROR_CODE)
                .then(function (translatedError) { return props.reject({
                status: status >= 200 && status < 400 ? 'OK' : 'FAILURE',
                errorCode: status,
                paymentMethod: props.request.payment.details.paymentMethod,
                translatedError: translatedError
            }); });
        };
        this.initializePayment = function (method, host) {
            if (host === void 0) { host = ''; }
            var selectedMethod = method || _this.activePaymentMethod;
            var getDetailsId = function (resolve, reject, tokenData, installments) {
                if (installments === void 0) { installments = 1; }
                var paymentDetails = {
                    details: {
                        paymentMethod: selectedMethod,
                        installments: installments,
                        creditCardToken: {
                            token: tokenData.token
                        },
                        additionalData: {}
                    }
                };
                axios_1.default.post(host + config.paymentDetailsUrl, paymentDetails)
                    .then(function (result) { return resolve(result.data); })
                    .catch(function (e) {
                    var status = e && e.response && e.response.status;
                    reject({
                        status: status >= 200 && status < 400 ? 'OK' : 'FAILURE',
                        errorCode: status,
                        translatedError: '',
                        paymentMethod: method
                    });
                });
            };
            return (new Promise(function (resolve, reject) {
                var publicDataPromise = selectedMethod === 'creditCard' ? _this.getCreditCardPublicData() : Promise.resolve();
                publicDataPromise.then(function (publicData) {
                    _this.tokenize(selectedMethod).then(function (data) {
                        var installments = publicData && publicData.additionalInformation && publicData.additionalInformation.installments;
                        return getDetailsId(resolve, reject, data.token, installments || 1);
                    }).catch(function (e) {
                        if (selectedMethod === 'creditCard') {
                            if (e && e.errorCode) {
                                _this.localizeError(e.errorCode).then(function (errorMessage) {
                                    reject({ errorCode: e.errorCode, translatedError: errorMessage, paymentMethod: selectedMethod });
                                });
                            }
                            else {
                                reject(e);
                            }
                        }
                        else {
                            return getDetailsId(resolve, reject, '', 1);
                        }
                    });
                });
            }));
        };
        this.resolveCountry = function (host) {
            if (host === void 0) { host = ''; }
            return (new Promise(function (resolve, reject) {
                if (_this.props && _this.props.query && _this.props.query.country) {
                    return resolve({
                        status: 'OK',
                        errorCode: '',
                        translatedError: '',
                        country: _this.props.query.country
                    });
                }
                return axios_1.default.get(host + config.resolveCountryUrl).then(function (response) {
                    var countryCode = response.data && response.data.country;
                    resolve({
                        status: 'OK',
                        errorCode: '',
                        translatedError: '',
                        country: countryCode
                    });
                }).catch(function (e) { return reject({
                    status: 'FAILURE',
                    errorCode: '500',
                    translatedError: '',
                    country: ''
                }); });
            }));
        };
        this.setCountry = function (country) {
            if (_this.props && _this.props.query) {
                _this.props.query.country = country;
            }
            else if (_this.props && !_this.props.query) {
                _this.props.query = { country: country };
            }
        };
        this.fetchTokenForSavedCreditCard = function (_a, host) {
            var creditCardId = _a.creditCardId, accountId = _a.accountId, _b = _a.cvv, cvv = _b === void 0 ? null : _b;
            return axios_1.default.post(interpolate_1.default(host + config.tokenForSavedCard, { creditCardId: creditCardId }), { accountId: accountId, cvv: cvv }).then(function (response) { return response.data; });
        };
        this.isRTLLocale = function (locale) {
            if (locale === void 0) { locale = ''; }
            if (locale.length !== 2 && locale.length !== 3) {
                console.error('Locale should contain 2 or 3 letters');
            }
            var RTL_LOCALES = [
                'ar',
                'arc',
                'bcc',
                'bqi',
                'ckb',
                'dv',
                'fa',
                'glk',
                'he',
                'ku',
                'mzn',
                'pnb',
                'ps',
                'sd',
                'ug',
                'ur',
                'yi',
            ];
            return RTL_LOCALES.indexOf(locale.toLowerCase()) !== -1;
        };
        this.getOrder = function (orderId, host) {
            if (host === void 0) { host = ''; }
            if (!host && _this.props && _this.props.host) {
                host = _this.props.host;
            }
            return axios_1.default.get(interpolate_1.default(host + config.orderUrl, { orderId: orderId })).then(function (response) {
                var order = response.data && response.data.order;
                return order;
            });
        };
        this.resources = resources;
    }
    return CashierPayments;
}());
exports.default = CashierPayments;
//# sourceMappingURL=sdk.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/sdk.js
// module id = 382
// module chunks = 0 1